
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AppInfoTab } from "./AppInfoTab";
import { AppScopeTab } from "./AppScopeTab";
import { AppNetworkRulesTab } from "./AppNetworkRulesTab";
import { App } from "@/types/app";

interface AppDetailModalProps {
  app: App;
  onClose: () => void;
  onDelete?: () => void;
  isDeleting?: boolean;
}

export const AppDetailModal = ({ app, onClose, onDelete, isDeleting }: AppDetailModalProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  // Get current tab from URL, default to 'info'
  const currentTab = searchParams.get('appTab') || 'info';

  // Handle tab changes and update URL
  const handleTabChange = (tab: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set('appTab', tab);
    setSearchParams(newParams);
  };

  return (
    <div className="h-full flex flex-col bg-white">
      {/* Tabs - app header info is now handled by main PageHeader */}
      <Tabs value={currentTab} onValueChange={handleTabChange} className="flex-1 flex flex-col overflow-hidden">
        {/* Fixed Tab Navigation */}
        <div className="flex-shrink-0 border-b border-gray-200 bg-white">
          <TabsList className="grid w-full grid-cols-3 bg-transparent h-auto p-0 rounded-none">
            <TabsTrigger 
              value="info" 
              className="data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-blue-500 data-[state=active]:text-blue-600 rounded-none py-3 px-4 text-sm"
            >
              General
            </TabsTrigger>
            <TabsTrigger 
              value="scope"
              className="data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-blue-500 data-[state=active]:text-blue-600 rounded-none py-3 px-4 text-sm"
            >
              Scope
            </TabsTrigger>
            <TabsTrigger 
              value="network"
              className="data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-blue-500 data-[state=active]:text-blue-600 rounded-none py-3 px-4 text-sm"
            >
              URLs
            </TabsTrigger>
          </TabsList>
        </div>

        {/* Scrollable Tab Content Container */}
        <div className="flex-1 overflow-hidden">
          <TabsContent value="info" className="h-full m-0 overflow-hidden">
            <AppInfoTab app={app} />
          </TabsContent>

          <TabsContent value="scope" className="h-full m-0 overflow-hidden">
            <AppScopeTab app={app} />
          </TabsContent>

          <TabsContent value="network" className="h-full m-0 overflow-hidden">
            <AppNetworkRulesTab app={app} />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};
